// ================================================================================
// HELPER FUNCTIONS
// --------------------------------------------------------------------------------
// This file contains helper functions that can be used throughout the project.
// New helper functions can be added here and imported in other files.
// ================================================================================

/**
 * Fomrats a price in cents to a formatted price in euros
 * @param {number} price the new price in cents
 * @param {string} locale the locale to format the price in
 * @param {string} currency the currency to format the price
 * @returns {string} the formatted price in euros
 * @example formatPrice(1234, 'nl-NL', 'EUR') => "€12.34"
 */
const formatPrice = (price, locale, currency) => {
    const formatter = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return formatter.format(price / 100).replace(/\s/g, "");
};
